import React from 'react'
import styled from 'styled-components'

const Loading = () => {
    return (
        <DivLoading>
            <i className="fa fa-spinner fa-spin fa-2x" />
            <label>Loading</label>
        </DivLoading> 
    )
}

const DivLoading = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    > label {
        margin-top: 24px;
        font-size: 16px;
    }
`

export default Loading